import React from "react";
import { connect } from 'react-redux';
import lodashGet from 'lodash/get';

/* MUI components */
import {
    Grid, Typography, Box,
    DialogTitle, Dialog, IconButton, Divider, } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';

/* React components */
//import AbonnementPayment from "./abonnementPayment"; //Imposible de le retirer sinon l'affichage de la carte bleue n'est pas correct
import AbonnementSkeleton from "./abonnementSkeleton";
import PlanCard from "./planCard";
import CustomIFrame from "../customIFrame";
import LogoSpotifarm from '../../assets/logoSpotifarm/FeuilleSpotifarmLogoCouleur';

/* Redux */
import { ActionGetAllPermissions } from '../../redux/actions/clientUser.js';

/* css */
import '../../assets/css/profil.css';

/* Utils */
import ConfigAuthent from '../../utils/configAuthent';
import ConstantsTutorialHelps from "../../utils/constantsTutorialHelps";
import { PermissionsHelper, Permissions } from "../../utils/permissionsHelper";
import dateHelper from "../../utils/dateHelper";
import StringTranslate from "../../assets/i18n/stringLanguage";

/* Theme */
import getTheme from "../../themes/index.js";
let theme = getTheme();


class Abonnements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stripe: null,
            completeAddress: props.address,

            openSubscriptionFormDialog: false,

        }

    }

    /* fonction cycle de vie react.js */
    componentDidMount() {
        const {getAllPermissions, allPermissions} = this.props;
        /* Enregistrement dans Redux du nom de la page actuelle */
        if (window.Stripe) {
            this.setState({ stripe: window.Stripe(ConfigAuthent.stripeApiKey) });
        } else {
            document.querySelector('#stripe-js').addEventListener('load', () => {
                // Create Stripe instance once Stripe.js loads
                this.setState({ stripe: window.Stripe(ConfigAuthent.stripeApiKey) });
            });
        }

        // ↓ Récupération des permissions ↓
        if (allPermissions.length <= 0) {
            getAllPermissions()
        }
    }

    openSubscriptionForm = () => {
		this.setState({
			openSubscriptionFormDialog: true,
		});
    }

    handleCloseSubscriptionForm = () => {
		this.setState({
			openSubscriptionFormDialog: false,
		});
    }

    render() {
        const {openSubscriptionFormDialog} = this.state;
        const {userDatas, enumTypoClient, gettingAllPermissions, allPermissions, typoEndingDate} = this.props;

        //const enumTypoClient = userDatas.enumTypoClient;
        const isExplorer = enumTypoClient === 3;
        const isFreemium = enumTypoClient === 1;
        
        //On retire la permission de l'historique pour éviter de l'afficher dans la liste des permissions de l'utilisateur puisqu'actuellement on ne souhaite plus l'afficher
        const userPermissionsWithoutHistory = PermissionsHelper.filterPermissions(userDatas.permissions, [Permissions.History])

        //*Laisser les permissions statiques du TDP à cet endroit car elles ne seront potentiellement plus utilisées à l'avenir
        const staticTDPPermissions = [
            StringTranslate.exploitationNumbersPermissionDescription,
            StringTranslate.parcelsPermissionDescription,
            StringTranslate.surfacePermissionDescription,
            StringTranslate.geolocPermissionDescription,
            StringTranslate.adventitiousFloraPermissionDescription,
            StringTranslate.importPermissionDescription,
        ];

        //Traduction des typos, déplacement à cet endroit pour les traductions dans toutes les langues et pas seulement le français
        const TypoDescription = {
            1: StringTranslate.freemiumDescription,
            2: StringTranslate.tourDePlaineDescription,
            3: StringTranslate.explorerDescription,
            4: StringTranslate.modulationDescription,
            5: StringTranslate.tourDePlaineAndFumreDescription,
            6: StringTranslate.modulationAndFumureDescription,
        }

        //Traduction des typos, déplacement à cet endroit pour les traductions dans toutes les langues et pas seulement le français
        const PermissionsDescription = {
            1: [StringTranslate.historyPermissionDescription],
            2: [StringTranslate.modulationIntraparcelPermissionDescription, StringTranslate.modulationAutomaticZoningPermissionDescription, StringTranslate.modulationManualAndAutomaticPermissionDescription, StringTranslate.modulationStrategiesPermissionDescription, StringTranslate.modulationExportPermissionDescription],
            4: [StringTranslate.biomassPermissionDescription],
            8: [StringTranslate.fertilizerNitrogenDosageAdvicePermissionDescription, StringTranslate.fertilizerTargetPermissionDescription, StringTranslate.fertilizerFractionalAdvicePermissionDescription, StringTranslate.fertilizerWheatLNIPermissionDescription, StringTranslate.fertilizerReserveDosePermissionDescription, StringTranslate.fertilizerPPFEditionPermissionDescription],
            16: [StringTranslate.modelingPermissionDescription],
            32: [StringTranslate.harvestPermissionDescription],
        }

        //Permissions manquantes à l'utilisateur (sans la fumure et l'historisation)
        const missingPermissions = PermissionsHelper.getMissingPermissions(allPermissions, userDatas.permissions, [Permissions.Fertilizer, Permissions.History]);

        //Permissions de tour de plaine (on retire la modulation pour séparer les deux abonnements)
        const missingPermissionsForTDP = PermissionsHelper.filterPermissions(missingPermissions, [Permissions.Modulation ]);
        const permissionsForTDP = PermissionsHelper.filterPermissions(allPermissions, [Permissions.Modulation, Permissions.Fertilizer, Permissions.History]);
        const permissionsToUseForTDP = isExplorer ? permissionsForTDP : missingPermissionsForTDP;
    
        //Permissions de modulation
        const missingPermissionsForModul = PermissionsHelper.getPermissionsByEnum(missingPermissions, Permissions.Modulation);
        const permissionsForModul = PermissionsHelper.getPermissionsByEnum(allPermissions, Permissions.Modulation);
        const permissionsToUseForModul = isExplorer ? permissionsForModul : missingPermissionsForModul;

        //Permissions de fumure
        const permissionsForFertilizer = PermissionsHelper.getPermissionsByEnum(allPermissions, Permissions.Fertilizer);

        //Temps restant pour l'abonnement Explorer
        const daysLeftForExplorer = dateHelper.calculateDaysLeft(typoEndingDate);

        //Pour gérer l'affichage mobile de certains composants
        const isMobile = window.matchMedia("(max-width: 600px)").matches;
        
        return (
            <>
                {gettingAllPermissions ?
                    <AbonnementSkeleton /> //Skeleton qui s'affiche en attendant d'avoir récupérer les permissions
                :
                    <Grid container spacing={2}>
                        {/* Bandeau si on est en freemium ou explorer, avec le temps restant de l'abonnement */}
                        {(enumTypoClient && (enumTypoClient > 0) && (isExplorer || isFreemium)) &&
                            <Box 
                                sx={{
                                backgroundColor: theme.palette.secondary.light, 
                                padding: 2,
                                borderRadius: '8px', 
                                border: '1px solid #ddd', 
                                mt: 1,
                                ml: '20px',
                                textAlign: 'center',
                                borderColor: theme.palette.secondary.main,
                                width: '100%'
                                }}
                            >
                                <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                                    {(enumTypoClient && daysLeftForExplorer && daysLeftForExplorer > 0 && enumTypoClient > 0 && isExplorer) ?
                                    `${TypoDescription[enumTypoClient]} ${StringTranslate.daysLeftForExplorer} ${daysLeftForExplorer} ${StringTranslate.day}${daysLeftForExplorer > 1 ? 's' : ''}`:
                                    TypoDescription[enumTypoClient]
                                    }
                                </Typography>                                
                            </Box>
                            
                        }
                        {/* ↓ partie - AFFICHAGE des plans ↓ */}
                        <Grid item xs={12} container spacing={2}>
                            {/*Plan actuel de l'utilisateur qui ne s'affiche que s'il possède au moins un tour de plaine */}
                            {(enumTypoClient && (enumTypoClient > 0) && !isExplorer && !isFreemium) &&
                                <Grid item xs={12} sm={6} md={4}>
                                    <PlanCard
                                        title={TypoDescription[enumTypoClient] || StringTranslate.defaultDescriptionForTypo}
                                        currentSubscription={true}
                                        staticPermissions={staticTDPPermissions}
                                        dynamicPermissions={PermissionsHelper.getDescriptions(userPermissionsWithoutHistory, PermissionsDescription)}
                                        buttonText={StringTranslate.subscribe}
                                        onButtonClick={this.openSubscriptionForm}
                                        headerIcon={<LogoSpotifarm/>}
                                        cardStyles={{
                                            pt: 1.75,
                                            border: '2px solid',
                                            borderColor: theme.palette.secondary.main,
                                            bgcolor: theme.palette.secondary.light,
                                            "&:last-child": {
                                                paddingBottom: 0
                                            }
                                        }}
                                    />
                                </Grid>
                            }
                            {/* Abonnement Tour de plaine */}
                            {((enumTypoClient && (enumTypoClient > 0) && isExplorer) || (missingPermissionsForTDP.length > 0)) &&
                                <Grid item xs={12} sm={6} md={4}>
                                    <PlanCard
                                        title={StringTranslate.tourDePlaineSubscription}
                                        dynamicPermissions={PermissionsHelper.getDescriptions(permissionsToUseForTDP, PermissionsDescription)}
                                        staticPermissions={staticTDPPermissions}
                                        buttonText={StringTranslate.subscribe}
                                        onButtonClick={this.openSubscriptionForm}
                                        showButton={true}
                                    />
                                </Grid>
                            }
                            {/* Abonnement modulation */}
                            {((enumTypoClient && (enumTypoClient > 0) && isExplorer) || (missingPermissionsForModul.length > 0)) &&
                                <Grid 
                                    item
                                    direction="column"
                                    sx={{
                                        justifyContent: "center",
                                        alignItems: "center",
                                        mb: 2
                                    }}
                                    xs={12} 
                                    sm={6} 
                                    md={4}
                                >
                                    <Grid item xs={12} sm={6} md={4} sx={{mb: 2.5}}>
                                        <PlanCard
                                            title={StringTranslate.modulSubscription}
                                            dynamicPermissions={PermissionsHelper.getDescriptions(permissionsToUseForModul, PermissionsDescription)}
                                            staticPermissions={[]}
                                            buttonText={StringTranslate.subscribe}
                                            onButtonClick={this.openSubscriptionForm}
                                            abovePermissions={
                                                <>
                                                    <Typography textAlign="center" variant="h4" sx={{mt: 2}}>{StringTranslate.tourDePlaineSubscription}</Typography>
                                                    <Typography textAlign="center" variant="h4" sx={{mt: 2}}>+</Typography>
                                                </>
                                            }
                                            showButton={true}
                                        />
                                    </Grid>
                                </Grid>
                            }
                            {/*Option fumure */}
                            { ((userDatas.permissions) && userDatas.permissions.every((perm) => perm.Enum !== 8)) &&
                                <>
                                    <Grid item container xs={12} sm={6} md={4} spacing={2} sx={{ display: isMobile ? "block" : "flex"}}>
                                        <Grid item xs={isMobile ? 12 : 1} sm={isMobile ? 12 : 1} md={isMobile ? 12 : 1}>
                                            <Divider        
                                                orientation={isMobile ? "horizontal" : "vertical"}
                                                sx={{
                                                    "&::before, &::after": {
                                                        borderColor: theme.palette.primary.main,
                                                    },
                                                    alignItems: "center",
                                                }}      
                                            >
                                                <AddCircleOutlinedIcon fontSize="large" sx={{color:theme.palette.primary.main}}/>
                                            </Divider>
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 11} sm={isMobile ? 12 : 11} md={isMobile ? 12 : 11}>
                                            <PlanCard
                                                title={StringTranslate.fertilizerOption}
                                                dynamicPermissions={PermissionsHelper.getDescriptions(permissionsForFertilizer, PermissionsDescription)}
                                                buttonText={StringTranslate.addOption}
                                                onButtonClick={this.openSubscriptionForm}
                                                belowTitle={StringTranslate.fertilizerOptionDescription}
                                                showButton={true}
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            <Dialog
                                open={openSubscriptionFormDialog}
                                onClose={this.handleCloseSubscriptionForm}
                                fullWidth
                                maxWidth={false}
                                sx={{
                                    '& .MuiDialog-paper': {
                                        width: '80%',
                                        maxHeight: '90vh',
                                    },
                                }}
                            >
                                <DialogTitle>
                                    <IconButton
                                        onClick={this.handleCloseSubscriptionForm}
                                        sx={{
                                            position: 'absolute',
                                            right: 8,
                                            top: 8,
                                            color: (theme) => theme.palette.grey[500],
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </DialogTitle>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <CustomIFrame className="iframes_profil" url={ConstantsTutorialHelps.UrlContactFormForSuscription}/>
                                    </Grid>
                                </Grid> 
                            </Dialog>
                        </Grid>
                    </Grid>
                }
            </>
        )
    }
}

const mapStateToProps = state => ({

    enumTypoClient: lodashGet(state, 'clientUserData.clientDatas.enumTypoClient', -1),
    clientId: lodashGet(state, 'clientUserData.clientDatas.id', -1),
    userId: lodashGet(state, 'clientUserData.userDatas.id', -1),
    isAdvClient: lodashGet(state, 'clientUserData.clientDatas.id', false),
    userDatas: lodashGet(state, 'clientUserData.userDatas', {}), //Utilisation du userDatas, suite à l'évolution du multi-users
    typoEndingDate: lodashGet(state, 'clientUserData.clientDatas.typoEnding', null), //Date de fin de la typo Explorer

    //Permissions
    gettingAllPermissions: lodashGet(state, 'clientUserData.gettingAllPermissions', false),
    allPermissions: lodashGet(state, 'clientUserData.allPermissions', {}),

    // Pour StripeCreditCardView.jsx
    creditCard: lodashGet(state, 'clientUserData.clientDatas.creditCard', null),
    subscriptionProcess: lodashGet(state, 'clientUserData.subscriptionProcess', null),
    language: lodashGet(state, 'settingsData.settings.language', 'FR'),
    naming: lodashGet(state, 'clientUserData.clientDatas.naming', ''),
    phone: lodashGet(state, 'clientUserData.clientDatas.phone', ''),
    address: lodashGet(state, 'clientUserData.clientDatas.address', {}),
    clientDatas: lodashGet(state, 'clientUserData.clientDatas', {}),
    codeCountry: lodashGet(state, 'settingsData.settings.codeCountry', ''),
    isNewSubscription: lodashGet(state, 'clientUserData.isNewSubscription', false),
    gettingPlansSubscriptions: lodashGet(state, 'clientUserData.gettingPlansSubscriptions', false),
    waitLoadingClient: lodashGet(state, 'clientUserData.isWaitingToSearchClient', false),
    planSubscriptionDico: lodashGet(state, 'clientUserData.planSubscriptionDico', {}),
})

const mapDispatchToProps = dispatch => ({
    //Pour gérer les permissions
    getAllPermissions: () => dispatch(ActionGetAllPermissions()),

})

export default connect(mapStateToProps, mapDispatchToProps)(Abonnements);
